import { useEffect, useState } from "react";

const useVoucherDetail = () => {
  const [expand, setExpand] = useState("");

  const handleExpand = (value) => {
    setExpand(value === expand ? "" : value);
  };

  useEffect(() => {
    document.body.className = "overflow-hidden pointer-events-none";
    return () => {
      document.body.className = "";
    };
  }, []);

  return {
    expand,
    handleExpand,
  };
};

export default useVoucherDetail;
